// CHG-131 REQ-CP-002: 16색 프로필 팔레트 (공용)
// - 양쪽(server/client) 모두 import 가능하도록 shared 패키지에 배치
// - bgClass(500계) = 아바타 배경, textClass(700계) = 이름 텍스트
// - softBgClass(100계) + softTextClass(700계) = 멘션 칩 배경+텍스트

export const PROFILE_COLOR_PALETTE = [
  { key: 'slate',   hex: '#475569', bgClass: 'bg-slate-500',   textClass: 'text-slate-700',   softBgClass: 'bg-slate-100',   softTextClass: 'text-slate-700' },
  { key: 'red',     hex: '#dc2626', bgClass: 'bg-red-500',     textClass: 'text-red-700',     softBgClass: 'bg-red-100',     softTextClass: 'text-red-700' },
  { key: 'orange',  hex: '#ea580c', bgClass: 'bg-orange-500',  textClass: 'text-orange-700',  softBgClass: 'bg-orange-100',  softTextClass: 'text-orange-700' },
  { key: 'amber',   hex: '#d97706', bgClass: 'bg-amber-500',   textClass: 'text-amber-700',   softBgClass: 'bg-amber-100',   softTextClass: 'text-amber-700' },
  { key: 'yellow',  hex: '#ca8a04', bgClass: 'bg-yellow-500',  textClass: 'text-yellow-700',  softBgClass: 'bg-yellow-100',  softTextClass: 'text-yellow-700' },
  { key: 'lime',    hex: '#65a30d', bgClass: 'bg-lime-500',    textClass: 'text-lime-700',    softBgClass: 'bg-lime-100',    softTextClass: 'text-lime-700' },
  { key: 'green',   hex: '#16a34a', bgClass: 'bg-green-500',   textClass: 'text-green-700',   softBgClass: 'bg-green-100',   softTextClass: 'text-green-700' },
  { key: 'teal',    hex: '#0d9488', bgClass: 'bg-teal-500',    textClass: 'text-teal-700',    softBgClass: 'bg-teal-100',    softTextClass: 'text-teal-700' },
  { key: 'cyan',    hex: '#0891b2', bgClass: 'bg-cyan-500',    textClass: 'text-cyan-700',    softBgClass: 'bg-cyan-100',    softTextClass: 'text-cyan-700' },
  { key: 'sky',     hex: '#0284c7', bgClass: 'bg-sky-500',     textClass: 'text-sky-700',     softBgClass: 'bg-sky-100',     softTextClass: 'text-sky-700' },
  { key: 'blue',    hex: '#2563eb', bgClass: 'bg-blue-500',    textClass: 'text-blue-700',    softBgClass: 'bg-blue-100',    softTextClass: 'text-blue-700' },
  { key: 'indigo',  hex: '#4f46e5', bgClass: 'bg-indigo-500',  textClass: 'text-indigo-700',  softBgClass: 'bg-indigo-100',  softTextClass: 'text-indigo-700' },
  { key: 'violet',  hex: '#7c3aed', bgClass: 'bg-violet-500',  textClass: 'text-violet-700',  softBgClass: 'bg-violet-100',  softTextClass: 'text-violet-700' },
  { key: 'fuchsia', hex: '#c026d3', bgClass: 'bg-fuchsia-500', textClass: 'text-fuchsia-700', softBgClass: 'bg-fuchsia-100', softTextClass: 'text-fuchsia-700' },
  { key: 'pink',    hex: '#db2777', bgClass: 'bg-pink-500',    textClass: 'text-pink-700',    softBgClass: 'bg-pink-100',    softTextClass: 'text-pink-700' },
  { key: 'rose',    hex: '#e11d48', bgClass: 'bg-rose-500',    textClass: 'text-rose-700',    softBgClass: 'bg-rose-100',    softTextClass: 'text-rose-700' },
] as const;

export type ProfileColorKey = typeof PROFILE_COLOR_PALETTE[number]['key'];

// CHG-137: Zod enum 등 외부 사용 편의 — 키 배열 (16색)
export const PROFILE_COLOR_KEYS: readonly ProfileColorKey[] =
  PROFILE_COLOR_PALETTE.map((p) => p.key);

export function isValidProfileColor(key: unknown): key is ProfileColorKey {
  return typeof key === 'string' && PROFILE_COLOR_PALETTE.some((p) => p.key === key);
}

export function getColorClasses(key: ProfileColorKey | null | undefined) {
  if (!key) return PROFILE_COLOR_PALETTE[10]; // fallback: blue
  return PROFILE_COLOR_PALETTE.find((p) => p.key === key) ?? PROFILE_COLOR_PALETTE[10];
}

/**
 * 클라이언트 fallback 전용 — 브라우저에서 displayColor가 NULL일 경우만 사용.
 * 마이그레이션 이후 모든 사용자가 displayColor를 보유하므로 평시 실행되지 않는다.
 * 서버/SQL은 md5 byte-sum 알고리즘을 사용 (분포 일치는 보장하지 않음 — 사용자 결정).
 * djb2: 브라우저 호환(crypto 의존성 없음), 동일 userId → 동일 결과 보장.
 */
export function pickColorByUserIdFallback(userId: string): ProfileColorKey {
  if (!userId) return PROFILE_COLOR_PALETTE[10].key; // blue
  let h = 0;
  for (let i = 0; i < userId.length; i++) {
    h = ((h << 5) - h) + userId.charCodeAt(i);
    h |= 0;
  }
  return PROFILE_COLOR_PALETTE[Math.abs(h) % PROFILE_COLOR_PALETTE.length].key;
}
